import { useRouter } from "next/router"

import { StudentProfileKey, toBaseStudentProfileKey } from "~/@shared/entities/StudentProfileKey"

export const SCOUT_ID_QUERY = "showCmtScout"

export const SHOW_CONFIRM_ADVANCE_YEAR_QUERY = "showConfirmAdvanceYear"

type QueryKey = typeof SCOUT_ID_QUERY | typeof SHOW_CONFIRM_ADVANCE_YEAR_QUERY

type ProfilePageQuery = {
  [_ in QueryKey]?: string
}

export const useProfilePageQuery = (): ProfilePageQuery => {
  const router = useRouter()
  return router.query as ProfilePageQuery
}

export const DATA_BASE_PROFILE_KEY_ATTR = "data-base-profile-key"

export const scrollByProfileKey = (key: StudentProfileKey) => {
  if (typeof window === "undefined") return

  const baseKey = toBaseStudentProfileKey(key)
  const elements = [...document.querySelectorAll(`[${DATA_BASE_PROFILE_KEY_ATTR}]`)] as Array<HTMLElement>
  const targetEl = elements.find((el) => el.getAttribute(DATA_BASE_PROFILE_KEY_ATTR)?.includes(baseKey))

  if (!targetEl || !document.scrollingElement) {
    return
  }
  document.scrollingElement.scrollTop = targetEl.offsetTop
}
